<template>
  <div id="the-menu" :class="{ active: active }">
    <Transition name="slide" mode="out-in">
      <div v-if="active" class="ll-menu-container">
        <div class="ll-menu-content">
          <div class="close-button" @click="$emit('close-menu')">
            <CloseButtonImage />
          </div>
          <ul class="menu">
            <li
              :class="{ active: activePage == 'questions' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/fragen">Alle Fragen</RouterLink>
            </li>
            <li
              :class="{ active: activePage == 'grundwissen' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/grundwissen">Grundwissen</RouterLink>
            </li>
            <li
              :class="{ active: activePage == 'b' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/b-fuehrerschein">B-Führerschein</RouterLink>
            </li>
            <li
              :class="{ active: activePage == '5-point-questions' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/5-punkte-fragen">5-Punkte Fragen</RouterLink>
            </li>
            <li
              :class="{ active: activePage == 'hard-questions' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/schwere-fragen">Schwere Fragen</RouterLink>
            </li>
            <li
              v-if="user"
              :class="{ active: activePage == 'wrong-questions' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/falsch-beantwortete"
                >Falsch beantwortete Fragen</RouterLink
              >
            </li>
            <li v-else class="disabled">Falsch beantwortete Fragen</li>
            <li
              :class="{ active: activePage == 'question' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/frage">Frage suchen nach ID</RouterLink>
            </li>
            <li
              :class="{ active: activePage == 'test' }"
              @click="$emit('close-menu')"
            >
              <RouterLink to="/pruefung">Prüfungssimulator</RouterLink>
            </li>
            <li
              v-if="user"
              class="logout"
              @click="
                $emit('close-menu');
                $emit('logout');
              "
            >
              Abmelden
            </li>
            <li v-else class="logout" @click="$emit('close-menu')">
              <RouterLink to="/login">Anmelden</RouterLink>
            </li>
          </ul>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import CloseButtonImage from "@/assets/CloseButton.svg";
import { mapGetters } from "vuex";

export default {
  name: "TheMenu",
  components: { CloseButtonImage },
  props: {
    active: Boolean,
  },
  computed: {
    activePage() {
      let name = this.$route.name;
      if (
        name == "grundwissen" ||
        name == "grundwissen-group" ||
        name == "grundwissen-subject"
      )
        return "grundwissen";
      switch (name) {
        case "grundwissen":
        case "grundwissen-group":
        case "grundwissen-subject":
          return "grundwissen";
        case "b-fuehrerschein":
        case "b-subject":
        case "b-group-subject":
          return "b";
        default:
          return this.$route.name;
      }

      return null;
    },
    ...mapGetters(["user"]),
  },
};
</script>

<style lang="scss" scoped>
#the-menu {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  z-index: 1000;

  .close-button {
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
    padding: 10px;
  }

  .ll-menu-container {
    color: $green;
    background: #ffffff;
    position: absolute;
    height: 100%;
    width: 350px;
    box-shadow: -7px 0px 15px 0px black;

    .ll-menu-content {
      position: fixed;
      width: 350px;
      padding: 40px;

      .menu {
        padding-top: 40px;
        list-style-type: none;

        li {
          padding: 5px 0 5px 5px;
          border-left: 5px solid transparent;
          transition: border-left 0.2s ease-in-out;
          font-size: 1.2rem;
          color: $green;

          &:hover,
          &.active {
            border-left: 5px solid $blue;
            cursor: pointer;

            a {
              color: $blue;
            }
          }
          &.disabled {
            cursor: default;
            color: $gray;
            opacity: 0.8;
            &:hover {
              border-left-color: transparent;
              cursor: not-allowed;
            }
          }
          a {
            color: $green;
            transition: color 0.2s ease-in-out;
          }

          &.logout {
            margin-top: 20px;
          }
        }
      }
    }
  }
}

.slide-leave-active,
.slide-enter-active {
  transition: 0.3s;
}
.slide-enter {
  left: -350px;
}
.slide-enter-to {
  left: 0;
}
.slide-leave {
  left: 0;
}
.slide-leave-to {
  left: -350px;
}
</style>
